<template>
  <div id="footer">
    <!--div class="sections">
      <div class="section">
        <h3>Follow Us On</h3>
        <ul>
          <li>
            <ul id="social-networks">
              <li><a href="https://www.facebook.com/blog.maman" target="_blank"><icon name="brands/facebook-f" scale="1.5"/></a></li>
              <li><a href="https://www.twitter.com/Yoopies" target="_blank"><icon name="brands/twitter" scale="1.5"/></a></li>
              <li><a href="https://plus.google.com/u/0/111298487258711297476" target="_blank"><icon name="brands/google-plus-g" scale="1.5"/></a></li>
            </ul>
          </li>
          <li><a href="http://serialmother.yoopies.fr/" target="_blank">Check Out Our Blog</a></li>
          <li class="hide-mobile"><a href="https://itunes.apple.com/fr/app/baby-sitting-yoopies/id540474688?mt=8" target="_blank"><img src="../assets/images/app-store.svg" alt="App Store" class="download-app"></a></li>
          <li class="hide-mobile"><a href="https://play.google.com/store/apps/details?id=com.yoopies.babysittingandroid" target="_blank"><img src="../assets/images/google-play.svg" alt="App Store" class="download-app"></a></li>
        </ul>
      </div>
      <div class="section">
        <h3 class="hide-mobile">About Us</h3>
        <ul>
          <li class="hide-mobile"><a href="https://yoopies.fr/a-propos">How Does It Work?</a></li>
          <li><a @click="showContact" class="contact-text">Contact Us</a></li>
          <li class="hide-mobile"><a href="https://yoopies.fr/tribus-paris">Notre tribu à Paris</a></li>
          <li><a href="https://yoopies.com/">Yoopies in the World</a></li>
        </ul>
      </div>
      <div class="section">
        <h3 class="hide-mobile">Help and FAQs</h3>
        <ul>
          <li class="hide-mobile"><a href="https://guide.yoopies.fr/">Helpful Texts</a></li>
          <li class="hide-mobile"><a href="https://yoopies.fr/yuppies-youpiz-yoopise">Youpies, Youpiz, Yo... !</a></li>
          <li class="hide-mobile"><a href="https://yoopies.fr/tarif-baby-sitting">Babysitting Rates</a></li>
          <li><a href="https://yoopies.fr/">Home Page</a></li>
        </ul>
      </div>
      <div class="section">
        <h3 class="hide-mobile">Information</h3>
        <ul>
          <li class="hide-mobile"><a href="https://yoopies.fr/presse" target="_blank">Press</a></li>
          <li><a href="https://yoopies.fr/cgv/" target="_blank">Terms and Conditions</a></li>
          <li class="hide-mobile"><a href="http://jobs.yoopies.com/" target="_blank">Join Us</a></li>
          <li class="hide-mobile"><a href="https://yoopies.fr/entreprises" target="_blank">Companies</a></li>
        </ul>
      </div>
      <div class="section hide-mobile">
        <h3>Services</h3>
        <ul>
          <li><a href="https://yoopies.fr/baby-sitting">Childcare</a></li>
          <li><a href="https://yoopies.fr/soutien-scolaire">Tutoring</a></li>
          <li><a href="https://yoopies.fr/menage">Housekeeping</a></li>
          <li><a href="https://yoopies.fr/garde-animaux">Pet sitting</a></li>
          <li><a href="https://yoopies.fr/aide-a-domicile">Senior care</a></li>
          <li><a href="https://yoopies.fr/emploi">I'm looking for a job</a></li>
        </ul>
      </div>
    </div-->

    <div class="logo-footer">
      <img src="../assets/images/yoopies.svg" alt="Yoopies">
    </div>
    <div class="terms">
      <a href="https://static.yoopies.com/legal/GB/Yoopies-Legal_Mentions.pdf" target="_blank">Legal mentions</a>
    </div>

    <!--Contact v-show="isContactVisible" @close="closeContact"/-->
  </div>
</template>

<script>
import 'vue-awesome/icons/brands/facebook-f';
import 'vue-awesome/icons/brands/twitter';
import 'vue-awesome/icons/brands/google-plus-g';

import Icon from 'vue-awesome/components/Icon';
import Contact from './Contact';

export default {
  name: 'Footer',
  components: {
    Icon,
    Contact,
  },
  data() {
    return {
      isContactVisible: false,
    };
  },
  methods: {
    showContact() {
      this.isContactVisible = true;
    },
    closeContact() {
      this.isContactVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#footer {
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 15px;

  @media screen and (min-width: 720px){
    flex-direction: unset;
    padding-top: 30px;
    padding-bottom: 30px;
  }
}

.sections {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  @media screen and (min-width: 720px){
    flex-direction: unset;
    text-align: left;
  }
}

.section {
  margin-left: 15px;
  margin-right: 15px;
  display: inline-block;

  @media screen and (min-width: 950px){
    margin-left: 40px;
    margin-right: 40px;
  }

  h3 {
    margin-bottom: 18px;
    font-size: 18px;

    @media screen and (min-width: 720px){
      margin: 0px;
      color: #4a4a4a;
    }
  }

  ul {
    list-style-type: none;
    padding-left: 0;
    margin: auto;

    @media screen and (min-width: 720px){
      margin-bottom: 16px;
      margin-top: 16px;
    }
  }

  li {
    font-weight: bold;
    margin-bottom: 18px;
    font-size: 14px;

    @media screen and (min-width: 720px){
      margin-bottom: 8px;
      font-weight: normal;
    }
  }

  a {
    text-decoration: none;
    color: #4a4a4a;

    &:hover{
      color: #44b69f;
    }
  }
}

.logo-footer {
  margin-left: auto;
  margin-right: auto;

  img {
    height: 40px;
    margin-left: auto;
    margin-right: auto;
    display: block;

    @media screen and (min-width: 720px){
      height: 60px;
    }
  }
}
.terms {
  text-align: center;
  a {
    text-decoration: none;
    color: #4a4a4a;

    &:hover{
      color: #44b69f;
    }
  }
}

.download-app {
  height: 40px;
}

#social-networks li {
  display: inline-block;
  margin-right: 15px;
  margin-left: 15px;
  margin-bottom: 0px;
  vertical-align: middle;

  @media screen and (min-width: 720px){
    margin-left: 0;
    margin-bottom: auto;
  }
}

.hide-mobile {
  display: none;

  @media screen and (min-width: 720px){
    display: block;
  }
}

.contact-text {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue